module.exports = __webpack_public_path__ + "kangping/img/icon4.b674b3f8.png";